//
//
//
//
import * as echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  name: 'lineEchart',
  props: ['chart'],
  mounted: function mounted() {
    var option = {
      xAxis: {
        type: 'category',
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      },
      yAxis: {
        type: 'value'
      },
      series: [{
        data: [150, 230, 224, 218, 135, 147, 260],
        type: 'line'
      }]
    }; // var chart = this.$refs[this.chart]
    // var myChart = this.$echarts.init(chart)

    var myChart = echarts.init(document.getElementById('main'));
    myChart.setOption(option);
  }
};